import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Pagination } from 'antd'
import noProfile from '../../images/noProfile.jpg'

const InactiveSubContractors = () => {

  const location = useLocation();
  const { contractors } = location.state || {};
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);


  const inactiveUsers = contractors?.filter(activeUser => activeUser?.active === false) || []

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentSubContractors = inactiveUsers.slice(indexOfFirstItem, indexOfLastItem);


  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  useEffect(()=> {
    console.log("Helloooo", inactiveUsers)
  }, [])


  return (

    <div className="p-4">
      <div className="flex flex-row justify-between items-center">
        <h2 className="text-2xl font-bold">Inactive Sub Contractors</h2>
      </div>
      <table className="min-w-full mt-7 bg-white border border-b-4 border-black">
        <thead>
          <tr className="bg-gray-800 text-white">
            <th className="py-2 px-4 border-b text-center">S.No</th>
            <th className="py-2 px-4 border-b text-center">Profile Pic</th>
            <th className="py-2 px-4 border-b text-center">Name</th>
            <th className="py-2 px-4 border-b text-center">Email</th>
            {/* <th className="py-2 px-4 border-b text-center">Domain Name</th> */}
            <th className="py-2 px-4 border-b text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          {currentSubContractors?.length > 0 ? (
            currentSubContractors.map((subContractor, index) => (
              <tr
                key={subContractor.id}
                className={`hover:bg-gray-200 text-center transition duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-300'}`}
              >

                <td className="py-2 px-4 border-b">{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td className="py-2 px-4 border-b">
                  <div className="flex items-center justify-center">
                  {subContractor?.profileImage ? <img
                      src={subContractor?.profileImage}
                      alt="subcontractor"
                      className="w-30 h-24 object-cover mr-2 border border-gray-700"
                      style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                    /> : 
                    <img
                    src={noProfile}
                    alt="subcontractor"
                    className="w-30 h-24 object-cover mr-2 border border-gray-700"
                    style={{ height: "50px", width: "50px", borderRadius: "50%" }}
                    /> }
                  </div>
                </td>
                <td className="py-2 px-4 border-b">{subContractor.firstName}</td>
                <td className="py-2 px-4 border-b">{subContractor.email}</td>
                {/* <td className="py-2 px-4 border-b">{subContractor.domain}</td> */}
                <td className="py-2 px-4 border-b">
                  <span className={`py-0.5 px-2 text-[20px] font-medium w-fit ${subContractor.active ? "text-green-500" : "text-red-500"}`}>
                    {subContractor.active ? "Active" : "Inactive"}
                  </span>
                </td>

              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="py-2 px-4 border-b text-center">No Inactive Subcontractor Found</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="mt-4 flex justify-end">
        <Pagination
          current={currentPage}
          total={inactiveUsers.length}
          pageSize={itemsPerPage}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </div>
  )
}

export default InactiveSubContractors